"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.raise = void 0;
/**
 * Throw an error.
 * @param err The error to throw.
 */
function raise(err) {
    throw err;
}
exports.raise = raise;
//# sourceMappingURL=error.js.map